
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 44 44"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14 7a1 1 0 012 0v8a1 1 0 01-2 0V7zm14 0a1 1 0 012 0v8a1 1 0 01-2 0V7zm6.243 31H9.757C7.683 38 6 36.331 6 34.274V13.726C6 11.669 7.683 10 9.757 10h24.486C36.317 10 38 11.669 38 13.726v20.548C38 36.331 36.317 38 34.243 38zm-.102-2A1.85 1.85 0 0036 34.161V13.84A1.85 1.85 0 0034.14 12H9.86A1.85 1.85 0 008 13.839V34.16A1.85 1.85 0 009.86 36h24.28zM32 31c0 1.106-.894 2-2 2-1.106 0-2-.894-2-2 0-1.106.894-2 2-2 1.106 0 2 .894 2 2zm0-8c0 1.106-.894 2-2 2-1.106 0-2-.894-2-2 0-1.106.894-2 2-2 1.106 0 2 .894 2 2zm-8 8c0 1.106-.894 2-2 2-1.106 0-2-.894-2-2 0-1.106.894-2 2-2 1.106 0 2 .894 2 2zm0-8c0 1.106-.894 2-2 2-1.106 0-2-.894-2-2 0-1.106.894-2 2-2 1.106 0 2 .894 2 2zm-8 8c0 1.106-.894 2-2 2-1.106 0-2-.894-2-2 0-1.106.894-2 2-2 1.106 0 2 .894 2 2zm0-8c0 1.106-.894 2-2 2-1.106 0-2-.894-2-2 0-1.106.894-2 2-2 1.106 0 2 .894 2 2z"}})])
          )
        }
      }
    